import { environment } from 'src/environments/environment';

/**
 * Configuración en tiempo de ejecución para despliegue en contenedor (Docker).
 *
 * Lee `assets/config.json` al arrancar y, si trae valores, sobrescribe la URL del API
 * (y la de imágenes del home) SIN recompilar: en Docker el `config.json` lo monta el
 * compose según el ambiente. Si el archivo no existe o el valor viene vacío, se conserva
 * el valor compilado en `environment` (fallback). Nunca hace fallar el arranque.
 *
 * Se ejecuta en `main.ts` ANTES de `bootstrapApplication`, de modo que corre antes de que
 * exista el inyector y, por tanto, antes de que cualquier servicio capture
 * `environment.backUrlApi` al construirse (hacerlo como APP_INITIALIZER era una carrera).
 */
interface RuntimeConfig {
    backUrlApi?: string;
    homeImagesUrl?: string;
}

export async function loadRuntimeConfig(): Promise<void> {
    try {
        const resp = await fetch('assets/config.json', { cache: 'no-cache' });
        if (!resp.ok) {
            return; // sin archivo servible → fallback a environment
        }
        const cfg = (await resp.json()) as RuntimeConfig;
        if (typeof cfg?.backUrlApi === 'string' && cfg.backUrlApi.trim().length > 0) {
            environment.backUrlApi = cfg.backUrlApi;
        }
        if (typeof cfg?.homeImagesUrl === 'string' && cfg.homeImagesUrl.trim().length > 0) {
            environment.homeImagesUrl = cfg.homeImagesUrl;
        }
    } catch {
        // config.json ausente o no parseable → fallback silencioso a environment
    }
}
